import { useMutation } from '@tanstack/react-query';

import { companyIdState } from '../company.state';
import { useCompanyFetchMode } from '../company-fetch-context';
import type { EditCompanyProductsPayload } from '@/api/v4/organization.api';
import { editCompanyProducts } from '@/api/v4/organization.api';
import { queryClient, QueryKey } from '@/config/query-client';
import { notify } from '@/ui/snackbar/notify';
import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';

export const useEditCompanyProducts = () => {
  const { t } = useTranslation('default');
  const companyId = useAtomValue(companyIdState);
  const fetchMode = useCompanyFetchMode();

  return useMutation({
    mutationFn: async (payload: EditCompanyProductsPayload) =>
      companyId ? editCompanyProducts(companyId, payload) : undefined,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.CompanyProducts, fetchMode, companyId],
      });
    },
    onError: () => {
      notify({
        message: t`default:unknownError`,
      });
    },
  });
};
